import React from 'react'
import { connect } from 'react-redux'

import CallHistory from '../components/CallHistory'
import { getCallHistory, createCall, redirect } from '../actions'
import { getSubscriber, getUser } from '../selectors'

class CallHistoryView extends React.Component {
    constructor() {
        super()
        this.state = {}
        this.loadCallHistory = this.loadCallHistory.bind(this)
        this.redial = this.redial.bind(this)
    }
    componentDidMount() {
        this.loadCallHistory()
    }
    componentWillReceiveProps(props) {
        if (props.subscriber && (!this.props.subscriber || props.subscriber.username !== this.props.subscriber.username)) {
            this.loadCallHistory(props)
        }
    }
    redial(source, destination, profile, message) {
        this.props.redirect({
            pathname: `/connect/${source}`,
            query: { to: destination, profile: profile && profile.key || profile, message }
        })
    }
    loadCallHistory({ subscriber, getCallHistory, profiles } = this.props) {
        if (subscriber) {
            getCallHistory(subscriber).then(callHistory => {
                const calls = callHistory.reverse().reduce((calls, item) => {
                    if (item.method === 'BYE') {
                        const lastItem = calls.length && calls[calls.length - 1]
                        const lastItemTags = lastItem && lastItem.start && [lastItem.start.from_tag, lastItem.start.to_tag]
                        if (lastItemTags && lastItemTags.indexOf(item.from_tag) >= 0 && lastItemTags.indexOf(item.to_tag) >= 0) {
                            lastItem.end = item
                        } else {
                            calls.push({ end: item })
                        }
                    } else {
                        calls.push({ start: item })
                    }
                    return calls
                }, []).reverse().map(call => {
                    const { src_user, dst_ouser, request } = call.start || call.end
                    call.source = this.props.getSubscriber(src_user)
                    call.destination = this.props.getSubscriber(dst_ouser)
                    call.profile = request && request.profile && (profiles.find(p => p.value === request.profile) || request.profile)
                    call.message = request && request.message
                    return call
                })
                this.setState({ calls })
            })
        }
    }
    render() {
        const { subscriber = {}, profiles = [], allowRedial } = this.props
        const { calls = [] } = this.state
        return <CallHistory {...{ subscriber, calls, profiles }} onRedial={allowRedial && this.redial} />
    }
}

const mapStateToProps = (state, { subscriber, params }) => {
    const props = {
        profiles: state.config.profiles
    }
    if (params.subscriberId && !(subscriber && subscriber.username === params.subscriberId)) {
        props.subscriber = getSubscriber(state, params.subscriberId)
        props.getSubscriber = subscriberId => getSubscriber(state, subscriberId)
    }
    const user = getUser(state)
    props.allowRedial = props.subscriber && user.isInUnit(props.subscriber.unit_id)
    return props
}

export default connect(mapStateToProps, { getCallHistory, createCall, redirect })(CallHistoryView)



// WEBPACK FOOTER //
// ./containers/CallHistory.jsx